import { FormattedMessage } from 'react-intl';
import s from './RequiredFieldInfo.module.scss';

function RequiredFieldInfo() {
  return (
    <div className={s.requiredFieldInfo}>
      <FormattedMessage id="offerWizard.requiredFieldInfo" />
    </div>
  );
}

export default RequiredFieldInfo;
